<template>
  <div id="MailNotif" class="flex justify-end pr-4 mb-5"></div>
  <div id="Notification" class="flex flex-col items-center justify-center"></div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Notifs"
}
</script>

<style scoped>

</style>